/** @format */

import { tokenValueFormat } from 'src/pages/AIObservability/constant'
import { secondsFormat } from 'src/utils'

export interface ValueUnit {
  value: string
  unit?: string
}

/** 将 tokenValueFormat 结果拆成数值与单位（k / m） */
export function splitTokenValue(value?: number | null): ValueUnit {
  const token = tokenValueFormat(value)
  if (token.includes('k') || token.includes('m')) {
    const [num, unit] = token.split(/(k|m)/)
    return { value: num, unit }
  }
  return { value: token }
}

/** 将秒级耗时格式化并拆成 value / unit（ms | s）；复合单位整段放入 value */
export function splitDurationSec(seconds?: number | null): ValueUnit {
  const duration = secondsFormat((seconds ?? 0) * 1000)
  const match = duration.match(/^([\d.]+)(ms|s)$/)
  if (match) {
    return { value: match[1], unit: match[2] }
  }
  return { value: duration }
}
